import { MMONetworkSlave } from "@utils/types";
import { ProjectileData, ProjectileType } from "mmo-common";
import { GameObject, Scene, TweenGameObject } from "realms-engine";
import { Render3DGameObject } from "realms-engine-browser";
import THREE from "realms-three";

export class ProjectileGameObject
  extends GameObject
  implements MMONetworkSlave<"projectile">
{
  private render3D: Render3DGameObject;
  private opacityTween: TweenGameObject<number>;

  constructor(private state: ProjectileData) {
    super();

    this.render3D = this.addChild(
      new Render3DGameObject(this.createThreeObject(state))
    );
    this.render3D.setPosition(state.position);
    this.render3D.setQuaternion(state.quaternion);
    this.opacityTween = this.addChild(
      new TweenGameObject(
        () => this.getOpacity(),
        (v) => this.setOpacity(v)
      )
    );
    this.setOpacity(0);
  }

  onInit(scene: Scene): void {
    this.opacityTween.tween(1, this.state.appearTime);
    super.onInit(scene);
  }

  private getOpacity() {
    const obj = this.render3D.getThreeObject();
    if (!(obj instanceof THREE.Mesh)) {
      return 0;
    }
    return obj.material.opacity;
  }

  private setOpacity(opacity: number) {
    const obj = this.render3D.getThreeObject();

    if (!(obj instanceof THREE.Mesh)) {
      return 1;
    }
    obj.material.opacity = opacity;
    obj.material.transparent = true;
  }

  private createThreeObject(state: ProjectileData): THREE.Object3D {
    switch (state.config.type) {
      case ProjectileType.Orb: {
        return new THREE.Mesh(
          new THREE.SphereGeometry(state.config.radius),
          new THREE.MeshToonMaterial({ color: 0x00ff00 })
        );
      }
    }
  }

  onSlaveChanges(
    changes: Partial<ProjectileData>,
    newState: ProjectileData,
    oldState: ProjectileData
  ): void {
    if (changes.position !== undefined) {
      this.render3D.setPosition(newState.position);
    }
    if (changes.quaternion !== undefined) {
      this.render3D.setQuaternion(newState.quaternion);
    }
  }
}
